<template>
    <div>
        <p class="font-semibold" :style="{'margin-bottom': (rowData.customer[0].phone && rowData.customer[0].phone !== '') ? '0' : ''}"
           :class="(rowData.customer[0].user || rowData.customer[0].employee) ? 'cursor-pointer text-primary hover:font-semibold hover:underline' : ''"
           @click.stop="showDetailsCustomer">{{ getNameCustomer(rowData.customer[0]) }}</p>
        <div class="flex gap-2">
            <p style="color: #a0aec0;">{{ rowData.customer[0].phone }}</p>
            <vx-tooltip class="position-icon" :text="$t('menuCustomer.addCustomer')" position="top"
                        v-if="!rowData.customer[0].user && !rowData.customer[0].employee">
                <feather-icon icon="UserPlusIcon" class="text-primary"
                              svgClasses="h-4 w-4" @click.stop="addCustomer"/>
            </vx-tooltip>
        </div>

        <vs-popup class="holamundo" title="Thông tin khách hàng" fullscreen :active.sync="popupAddCustomer"
                  v-if="popupAddCustomer">
            <CustomerInformation :phone-number="rowData.customer[0].phone" :isProp="true"/>
        </vs-popup>

        <vs-popup class="holamundo" title="Thông tin khách hàng" fullscreen :active.sync="popupDetailsCustomer"
                  v-if="popupDetailsCustomer">
            <vs-tabs v-model="activeTab">
                <vs-tab label="Thông tin khách hàng">
                        <CustomerInformation :loyaltyCustomerId="rowData.id" :isRead="true"/>
                </vs-tab>
                <vs-tab label="Lịch sử cuộc gọi">
                        <CallHistory :phone="rowData.customer[0].phone"></CallHistory>
                </vs-tab>
                <vs-tab label="Lịch sử tư vấn">
                        <ConsultingStep :loyaltyCustomerId="getCustomerId(rowData.customer[0])"></ConsultingStep>
                </vs-tab>
                <vs-tab label="Lịch sử thanh toán">
                        <FeeCollectionStep :loyaltyCustomerId="getCustomerId(rowData.customer[0])"></FeeCollectionStep>
                </vs-tab>
                <vs-tab label="Lịch sử điều trị">
                        <SubclinicalStep :loyaltyCustomerId="getCustomerId(rowData.customer[0])"></SubclinicalStep>
                </vs-tab>
                <vs-tab label="Lịch sử nhắn tin">
                        <HistorySMS :loyaltyCustomerId="getCustomerId(rowData.customer[0])"></HistorySMS>
                </vs-tab>
                <vs-tab label="Lịch sử ra vào">
                        <InOutHistory :loyaltyCustomerId="getCustomerId(rowData.customer[0])"></InOutHistory>
                </vs-tab>
                <vs-tab label="Lịch sử đặt lịch">
                        <BookingHistory :loyaltyCustomerId="getCustomerId(rowData.customer[0])"></BookingHistory>
                </vs-tab>
            </vs-tabs>
        </vs-popup>
    </div>
</template>

<script>

import CustomerInformation from "@/views/user-pages/crm-module/customer/CustomerInformation";
import ConsultingStep from "@/views/user-pages/crm-module/customer/cell-renderer/medical-step/ConsultingStep";
import FeeCollectionStep from "@/views/user-pages/crm-module/customer/cell-renderer/medical-step/FeeCollectionStep";
import SubclinicalStep from "@/views/user-pages/crm-module/customer/cell-renderer/medical-step/SubclinicalStep";
import HistorySMS from "@/views/user-pages/crm-module/customer/cell-renderer/history-sms/HistorySMS";
import InOutHistory from "@/views/user-pages/crm-module/customer/cell-renderer/medical-step/InOutHistory";
import BookingHistory from "@/views/user-pages/crm-module/customer/cell-renderer/medical-step/BookingHistory";
import CallHistory from "@/views/user-pages/crm-module/customer/cell-renderer/medical-step/CallHistory";
import VuePerfectScrollbar from 'vue-perfect-scrollbar';

export default {
    name: "CellRendererCustomer",
    props: {
        rowData: {
            type: Object,
            required: true,
        },
    },
    components: {
        CustomerInformation,
        ConsultingStep,
        FeeCollectionStep,
        SubclinicalStep,
        HistorySMS,
        InOutHistory,
        BookingHistory,
        CallHistory,
        VuePerfectScrollbar
    },

    data() {
        return {
            popupAddCustomer: false,
            popupDetailsCustomer: false,
            settings: {
                maxScrollbarLength: 60,
                wheelSpeed: .30,
                suppressScrollX: true,
            },
            activeTab: 0,
        }
    },

    computed: {
        getCustomerId() {
            return value => {
                if (value.user) {
                    return value.user.employeeId;
                }
                return null
            }
        },

        getNameCustomer() {
            return value => {
                if (value.user) {
                    return value.user.fullName;
                } else if (value.employee) {
                    return value.employee.fullName;
                }
                return 'Không xác định'
            }
        }
    },

    methods: {
        addCustomer() {
            this.popupAddCustomer = true;
        },

        showDetailsCustomer() {
            this.activeTab = 0;
            if (this.rowData.customer[0].user || this.rowData.customer[0].employee) this.popupDetailsCustomer = true;
        }
    },

    mounted() {
        this.$eventBus.$on("popup-add-customer", (event) => {
            if (event) this.popupAddCustomer = false;
        })
    }
}
</script>

<style scoped>

</style>
